/* 
	<template>
		// 使用state标签，定义字典名称dict、值value
		<c-state dict="dictName" value="1"></c-state>
		// 使用异步数据定义async属性
		<c-state dict="dictName" async value="1"></c-state>
		
		// 下拉框、单复选框直接使用下面引入的选项数据
		<c-select :options="dictName"></c-select>
		<c-radio-group :options="dictName"></c-radio-group>
		<c-checkbox-group :options="dictName"></c-checkbox-group>
	</template>

	<script>
		// 获取本地选项数据
		// 导入mapState方法
		import {mapState} from 'vuex'
		export default {
			computed: {
				// 获取dictName选项数据
				...mapState(['dictName'])
			}
		}
		
		// 获取异步选项数据
		// 导入asyncMapState方法
		import {asyncMapState} from '@/store'
		export default {
			computed: {
				// 获取dictName选项数据
				...asyncMapState(['dictName'])
			}
		}
	</script>
 */

/* 支持颜色
 * gray 灰色
 * blue 蓝色
 * red 红色
 * green 绿色
 * yellow 黄色
 * orange 橙色
 */

export default {
	dictName: [{
		name: '状态1',
		value: 1,
		color: 'blue'
	}, {
		name: '状态2',
		value: 2,
		color: 'red'
	}],

	paperSize: [{
		name: 'A3',
		value: '29.7x42'
	}, {
		name: 'A4',
		value: '21x29.7'
	}, {
		name: 'A5',
		value: '14.8x21'
	}, {
		name: '自定义',
		value: 'auto'
	}],
	
	fieldType: [{
		name: '文本',
		value: 'text'
	}, {
		name: '数字',
		value: 'number'
	}, {
		name: '时间',
		value: 'time'
	}, {
		name: '选项',
		value: 'option'
	}, {
		name: '附件',
		value: 'file'
	}, {
		name: '图片',
		value: 'image'
	}, {
		name: '关联对象',
		value: 'rel_object'
	}, {
		name: '公式',
		value: 'formula'
	}],
	// 启用/停用
	disableEnableDic: [{
		name: '启用',
		value: 1,
		color: 'green'
	}, {
		name: '禁用',
		value: 2,
		color: 'gray'
	}],
	// 产品状态（1：启用，2：停用）
	productStateDic: [{
		name: '启用',
		value: 1,
		color: 'green'
	}, {
		name: '停用',
		value: 2,
		color: 'gray'
	}],
	//关闭、开启
	openCloseDic: [{
		name: '关闭',
		value: 0,
		color: 'gray'
	}, {
		name: '开启',
		value: 1,
		color: 'red'
	}],
	//允许不允许
	allowDisallowDic: [{
		name: '不允许',
		value: 0,
		color: 'gray'
	}, {
		name: '允许',
		value: 1,
		color: 'red'
	}],
	//默认
	defaultDic: [{
		name: '',
		value: 1,
		color: 'gray'
	}, {
		name: '默认',
		value: 2,
		color: 'green'
	}],
	//产品来源
	productSourceName: [{
		name: '自产',
		value: 1,
		color: 'green'
	},{
		name: '采购',
		value: 2,
		color: 'red'
	},  {
		name: '来料',
		value: 3,
		color: 'yellow'
	}],
	//产品类型
	productTypeName: [{
		name: '成品',
		value: 1,
		color: 'blue'
	},{
		name: '半成品',
		value: 3,
		color: 'orange'
	},  {
		name: '物料',
		value: 2,
		color: 'gray'
	}],
	//模板类型名称
	templateTypeName: [{
		name: '内置模板',
		value: 1,
		color: 'green'
	}, {
		name: 'Excel模板',
		value: 2,
		color: 'blue'
	}, {
		name: 'Excel模板',
		value: 3,
		color: 'brown'
	}],
	// 排产状态
	schedulingStateDic: [{
		name: '未排产',
		value: 0,
		color: 'orange'
	}, {
		name: '已排产',
		value: 1,
		color: 'green'
	}],
	// 订单状态
	salesOrderStateDic: [{
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已完成',
		value: 3,
		color: 'green'
	}, {
		name: '已暂停',
		value: 5,
		color: 'gray'
	}, {
		name: '已取消',
		value: 4,
		color: 'orange'
	}],
	// 单据状态
	orderStateDic: [{
		name: '未开始',
		value: 1,
		color: 'gray'
	}, {
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已结束',
		value: 3,
		color: 'green'
	}, {
		name: '已取消',
		value: 4,
		color: 'orange'
	}],
	// 单据状态(不含取消)
	orderStateNoCancelDic: [{
		name: '未开始',
		value: 1,
		color: 'gray'
	}, {
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已结束',
		value: 3,
		color: 'green'
	}],
	//优先级
	priorityDic: [
		{
			name: '',
			value: 0,
			color: 'gray'
		},
		{
			name: '加急',
			value: 1,
			color: 'red'
		}, {
			name: '暂停',
			value: 2,
			color: 'gray'
		},
	], 
	//优先级(无)
	prioritySelectDic: [
		{
			name: '加急',
			value: 1,
			color: 'red'
		}, {
			name: '暂停',
			value: 2,
			color: 'gray'
		}, {
			name: '无',
			value: 0,
			color: 'gray'
		}
	],
	//审核状态（含待提交）
	auditStateDic:[
		{
			name: '待提交',
			value: 0,
			color: 'gray'
		}, {
			name: '待审核',
			value: 1,
			color: 'blue'
		}, {
			name: '已审核',
			value: 2,
			color: 'green'
		}
	],
	//审核状态
	auditState2Dic:[
		{
			name: '待审核',
			value: 1,
			color: 'blue'
		}, {
			name: '已审核',
			value: 2,
			color: 'green'
		}
	],
	//审批状态
	approveStateDic:[
		{name: '待审批', value: 1, color: 'gray'},
		{name: '已审批', value: 2, color: 'green'}
	],
	//计价方式
	pricingTypeDic:[{
		name: '计件',
		value: 1,
		color: 'black'
	}, {
		name: '计时',
		value: 2,
		color: 'orange'
	}],
	//入库单 - 业务分类
	stockinClassifyName:[
		{name: '普通入库', value: 10, color: 'gray'},
		{name: '采购入库', value: 11, color: 'green'},
		{name: '成品入库', value: 12, color: 'blue'},
		{name: '调拨入库', value: 13, color: 'yellow'},
		{name: '销售退货入库', value: 14, color: 'red'},
		{name: '生产退料入库', value: 16, color: 'orange'},
		{name: '其他入库', value: 15, color: 'gray'}
	],
	//出库单 - 业务分类
	stockoutClassifyName:[
		{name: '普通出库', value: 20, color: 'gray'},
		{name: '销售出库', value: 21, color: 'green'},
		{name: '生产出库', value: 22, color: 'blue'},
		{name: '调拨出库', value: 23, color: 'yellow'},
		{name: '采购退货出库', value: 24, color: 'red'},
		{name: '生产领料出库', value: 26, color: 'orange'},
		{name: '委外发料出库', value: 27, color: 'orange'},
		{name: '其他出库', value: 25, color: 'gray'}
	],
	//盘点单 - 业务分类
	inventoryClassifyName:[
		{name: '期初盘点', value: 30, color: 'blue'},
		{name: '期末盘点', value: 31, color: 'orange'},
		{name: '其他盘点', value: 32, color: 'gray'}
	],
	//入库单/出库单/盘点单 - 业务分类
	stockClassifyName:[
		{name: '普通入库', value: 10, color: 'green'},
		{name: '采购入库', value: 11, color: 'green'},
		{name: '成品入库', value: 12, color: 'green'},
		{name: '调拨入库', value: 13, color: 'green'},
		{name: '销售退货入库', value: 14, color: 'green'},
		{name: '生产退料入库', value: 16, color: 'green'},
		{name: '其他入库', value: 15, color: 'green'},
		{name: '普通出库', value: 20, color: 'red'},
		{name: '销售出库', value: 21, color: 'red'},
		{name: '生产出库', value: 22, color: 'red'},
		{name: '调拨出库', value: 23, color: 'red'},
		{name: '采购退货出库', value: 24, color: 'red'},
		{name: '生产领料出库', value: 26, color: 'red'},
		{name: '委外发料出库', value: 27, color: 'red'},
		{name: '其他出库', value: 25, color: 'red'},
		{name: '期初盘点', value: 30, color: 'blue'},
		{name: '期末盘点', value: 31, color: 'blue'},
		{name: '其他盘点', value: 32, color: 'blue'}
	],
	//出入库单类型
	orderTypeName:[
		{name: '入库单', value: 4, color: 'green'},
		{name: '出库单', value: 5, color: 'red'},
		{name: '盘点单', value: 6, color: 'blue'}
	],
	//库存变化单据 （出库、入库、盘点） - 来源单据类型
	refTypeName:[
		{name: '自建', value: 0},
		{name: '报工', value: 14},
		{name: '工单', value: 3},
		{name: '发货', value: 32},
		{name: '采购', value: 39},
		{name: '生产入库检',value: 45,color: 'brey'}
	],
	//系统操作类型
	operationName:[
		{name: '创建', value: 1, color: 'green'},
		{name: '编辑', value: 2, color: 'blue'},
		{name: '删除', value: 3, color: 'red'}
	],
	//导入操作状态
	importStateName:[
		{name: '失败', value: 0, color: 'red'},
		{name: '部分成功', value: 1, color: 'yellow'},
		{name: '成功', value: 2, color: 'green'}
	],
	//外协单动态类型
	outSourcingOrderProcessName:[
		{name: '发货', value: 1, color: 'blue'},
		{name: '收货', value: 2, color: 'green'}
	],
	//外协单动态创建人类型(1=供应商 2=工厂用户)
	outSourcingOrderProcessCreateUserType:[
		{name: '供应商', value: 1, color: 'blue'},
		{name: '系统用户', value: 2, color: 'green'}
	],
	//报表时间粒度
	timeGranule: [{
		name: '每天',
		value: 'DAY'
	}, {
		name: '每周',
		value: 'WEEK'
	}, {
		name: '每月',
		value: 'MONTH'
	}, {
		name: '无',
		value: 'ALL'
	}],
	//库存状态
	stockStateName: [
		{name: '未设置', value: -1, color: 'gray'},
		{name: '低预警', value: 1, color: 'red'},
		{name: '正常', value: 2},
		{name: '超预警', value: 3, color: 'blue'}
	],
	//工期状态
	planDateStateName: [
		{name: '已逾期', value: 1, color: 'red'},
		{name: '正常', value: 2}
	],
	//委外状态
	outSourcingStateName: [
		{name: '存在委外', value: 1, color: 'blue'},
		{name: '无委外', value: 2}
	],
	//系统用户身份
	identityDic: [
		{name: '老板', value:'老板', color: 'green'},
		{name: '对接人', value: '对接人', color: 'blue'}
	],
	//系统用户角色
	rolesDic: [
		{name: '轻量-管理员', value:1, color: 'green'},
		{name: '轻量-生产人员', value:2, color: 'blue'}
	],
	// 业务范围
	businessTypeDic: [{
		name: '销售',
		value: 1,
		color: 'blue'
	}, {
		name: '发货',
		value: 2,
		color: 'green'
	}, {
		name: '报工(默认)',
		value: 3,
		color: 'orange'
	}],
	//订单库存占用状态
	occStatedic: [{
		name: '未占用',
		value: 1,
		color: 'gray'
	},{
		name: '已占用',
		value: 2,
		color: 'blue'
	}],
	// 协同任务状态
	collabTaskStateDic: [{
		name: '待响应',
		value: 1,
		color: 'gray'
	}, {
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已完成',
		value: 3,
		color: 'green'
	}],
	// 采购状态
	purchaseStateDic: [{
		name: '执行中',
		value: 2,
		color: 'blue'
	}, {
		name: '已完成',
		value: 3,
		color: 'green'
	}, {
		name: '已取消',
		value: 4,
		color: 'orange'
	}],
	//核准状态
	approvalStateDic: [{
		name: '待核准',
		value: 1,
		color: 'gray'
	}, {
		name: '已核准',
		value: 2,
		color: 'green'
	}],
	//加工类型
	processTypeDic: [{
		name: '自制',
		value: 1,
		color: 'green'
	}, {
		name: '外协',
		value: 2,
		color: 'blue'
	}],
	//检验方式
	testModeDic: [{
		name: '免检',
		value: 1,
		color: 'green'
	}, {
		name: '首检',
		value: 2,
		color: 'blue'
	}, {
		name: '全检',
		value: 3,
		color: 'orange'
	}],
	//生产顺序
	productionSequenceDic: [{
		name: '在前工序之后',
		value: 1,
		color: 'green'
	}, {
		name: '与前工序同时',
		value: 2,
		color: 'blue'
	}],
	//检验方式(不含免检)
	testModeQualityDic: [{
		name: '首检',
		value: 2,
		color: 'blue'
	}, {
		name: '全检',
		value: 3,
		color: 'orange'
	}],
	//检验状态(不含免检)
	testStateQualityDic: [{
		name: '未质检',
		value: 2,
		color: 'orange'
	}, {
		name: '已质检',
		value: 3,
		color: 'green'
	}],
	//检验状态
	testStateDic: [{
		name: '免检',
		value: 1,
		color: 'gray'
	}, {
		name: '未质检',
		value: 2,
		color: 'orange'
	}, {
		name: '已质检',
		value: 3,
		color: 'green'
	}],
	//报工类型
	outputTypeDic: [{
		name: '正常',
		value: 1,
		color: 'gray'
	}, {
		name: '返工',
		value: 2,
		color: 'orange'
	}],
	//不合格品处理方式
	afterTypeDic: [{
		name: '报废',
		value: 1,
		color: 'red'
	}, {
		name: '返工',
		value: 2,
		color: 'blue'
	}],
	//不合格品处理状态
	afterStateDic: [{
		name: '未处理',
		value: 1,
		color: 'blue'
	}, {
		name: '已处理',
		value: 2,
		color: 'green'
	}],
	//首检状态
	firestTestState: [{
		name: '未完成',
		value: 1,
		color: 'blue'
	}, {
		name: '已完成',
		value: 2,
		color: 'green'
	}],
	//装配工单来源单据类型
	AssembleRefTypeDic: [
		{
			name: '自建',
			value: 0,
			color: ''
		}, {
			name: '销售订单',
			value: 1,
			color: 'orange'
		}, {
			name: '生产计划',
			value: 2,
			color: 'green'
		}
	],
	//工单来源单据类型
	WorkRefTypeDic: [
		{
			name: '自建',
			value: 0,
			color: ''
		}, {
			name: '销售订单',
			value: 1,
			color: 'orange'
		}, {
			name: '生产计划',
			value: 2,
			color: 'green'
		},
		{
			name: '装配工单',
			value: 34,
			color: 'blue'
		},
		{
			name: '质检返工',
			value: 47,
			color: 'red'
		}
	],
	//用户类型
	userTypeDic: [{
		name: '员工',
		value: 1,
		color: 'blue'
	}, {
		name: '虚拟',
		value: 2,
		color: 'gray'
	}],
	//账户锁定状态
	lockStateDic: [{
		name: '正常',
		value: 0,
		color: 'green'
	}, {
		name: '已锁定',
		value: 1,
		color: 'red'
	}],
	materialProcessMethodDic: [{
		name: '外发后手动前往委外单发料',
		value: 0,
		color: 'red'
	},{
		name: '外发后自动生成发料动态',
		value: 1,
		color: 'green'
	}],
	//未分配，已分配
	distributeStateDic: [{
		name: '已分配',
		value: 1,
		color: 'gray'
	}, {
		name: '未分配',
		value: 2,
		color: 'red'
	}],
	//报工后自动成品入库，报工记录审批后自动成品入库
	autoInTimeTypeDic: [{
		name: '报工后立即执行',
		value: 0,
		color: 'gray'
	}, {
		name: '报工记录审批后执行',
		value: 1,
		color: 'red'
	}],
	//统计按工艺路线查询最后产出
	statisticscheckedDic: [{
		name: '开启',
		value: 1,
		color: 'gray'
	}],
	//BOM配置状态
	bomDicState: [{
		name: '未配置BOM',
		value: 0,
		color: 'gray'
	}, {
		name: '已配置BOM',
		value: 1,
		color: 'green'
	}],
	batchSourceOrderTypeDic:[{
		name: '自建',
		value: -1,
		color: 'gray'
	}, {
		name: '入库单',
		value: 0,
		color: 'green'
	}, {
		name: '工单',
		value: 3,
		color: 'blue'
	}, {
		name: '质检单',
		value: 45,
		color: 'blue'
	}, {
		name: '采购单',
		value: 39,
		color: 'blue'
	}],
	outputCountLimitTypeDic:[{
		name: '不限制',
		value: 0,
		color: 'gray'
	}, {
		name: '限制（良品数<=计划数）',
		value: 1,
		color: 'gray'
	}, {
		name: '限制（良品数+不良品数<=计划数）',
		value: 2,
		color: 'green'
	}],
	mobileTypeDic:[{
		name: 'H5网页',
		value: 1,
		color: 'gray'
	}, {
		name: '微信小程序',
		value: 2,
		color: 'green'
	}],
	dateFieldOptions:[{
		name: '报工创建时间', 
		value: 'create_date'
	},{
		name: '报工开始时间', 
		value: 'real_start_date'
	},{
		name: '报工结束时间', 
		value: 'real_end_date'}
	],
	//是否最后一道工序
	lastProcessStateDic: [{
		name: '否',
		value: 0,
		color: 'gray'
	}, {
		name: '是',
		value: 1,
		color: 'red'
	}],
	//返工类型
	reworkAfterTypeDic: [{
		name: '报废返工',
		value: 1,
		color: 'red'
	}, {
		name: '正常返工',
		value: 2,
		color: 'blue'
	}],
}